// extracted by mini-css-extract-plugin
export var grid = "fp-1T";
export var gridWithRowGap = "fp-2T";
export var languageSelector = "fp-7T";
export var languageSelector__item = "fp-8T";
export var languageSelector__itemFocus = "fp-0T";
export var languageSelector__itemSelected = "fp-9T";
export var maxWidthContainer = "fp-6T";
export var mt0 = "fp-VT";
export var mt1 = "fp-WT";
export var mt2 = "fp-XT";
export var mt3 = "fp-YT";
export var mt4 = "fp-ZT";
export var mt5 = "fp-_T";
export var mt6 = "fp--T";
export var removeVisuallyHidden = "fp-4T";
export var visuallyHidden = "fp-3T";
export var widgetBase = "fp-5T";